import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';

import { LandingComponent } from './landing.component';

const routes = [
    {
        path     : 'landing',
        component: LandingComponent
    }
];

@NgModule({
    declarations: [
        LandingComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        LandingComponent
    ]
})

export class LandingModule
{
}



// WEBPACK FOOTER //
// C:/Users/Marion Surgical/Desktop/Sean/marion-surgical-master/src/app/main/content/landing/landing.module.ts